/*
 * @Description: 
 * @Autor: lkz
 * @Date: 2021-06-25 10:49:11
 * @LastEditors: lkz
 * @LastEditTime: 2021-06-25 10:49:55
 */
export default [
  {
    path: '/woquSystem/login',
    name: '/home',
    meta: {
      title: '首页'
    },
    component: () =>
      import ( /* webpackChunkName: "example-configuration-center" */ '../views/woquSystem/login.vue')
  }
]